module.exports = require('./lib/patch')



//////////////////
// WEBPACK FOOTER
// ./~/react-hot-loader/patch.js
// module id = 28
// module chunks = 0